<template>
    <div :class="{'status-bar': true}">
        <el-alert
            :title="title"
            :closable="false"
            :type="type"
            class="status-bar-box"
            center
        >
            <slot />
        </el-alert>
    </div>
</template>

<script>

export default {
    name: 'StatusBar',

    props: {
        type: {
            type: String,
            default: 'info',
        },
        title: {
            type: String,
            default: null,
        },
    },
};
</script>

<style lang="scss">
    .status-bar {
        position: sticky;
        top: 0;
        width: 100%;
        display: flex;

        .el-alert .el-alert__description {
            margin-top: 0;
        }

        strong {
            font-weight: bold;
        }
    }
</style>

